var exports = {
  "AS": "xdde3148b--cdb1ae--item",
  "DD": "xdde3148b--cdb1ae--title",
  "Qs": "xdde3148b--cdb1ae--content",
  "Kk": "xdde3148b--cdb1ae--icon",
};

module.exports = exports;
